export default __webpack_public_path__ + "static/media/icon-ios.44c31ddd.svg";